export default "__VITE_ASSET__SS4yo2Go__"